// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9a2eef56","553":"31e81957","977":"dee8ce6d"}[chunkId] + ".chunk.js";
};